import App from './App.svelte';
const propagateUpdate = debounce(50, (el, start, end) => {
    el.querySelectorAll('[data-start]').forEach((input) => input.value = `${start}`);
    el.querySelectorAll('[data-end]').forEach((input) => input.value = `${end}`);
});
document.querySelectorAll('.product-slider-widget').forEach((el) => {
    new App({
        target: el,
        props: {
            step: parseFloat(el.dataset.steps),
            min: parseFloat(el.dataset.min),
            max: parseFloat(el.dataset.max),
            callback(start, end) {
                propagateUpdate(el, start, end);
            }
        }
    });
});
function debounce(wait = 100, func) {
    let timeout = null;
    return (el, start, end) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func(el, start, end);
        }, wait);
    };
}
export default app;
